(() => {
  const initialize = () => {
    const dialog = document.getElementById('clad-welcome-dialog');
    if (!dialog || dialog.dataset.eligible !== 'true' || dialog.dataset.cladReady || typeof dialog.showModal !== 'function') return;

    const shopify = window.Shopify || {};
    const previewAllowed = shopify.designMode || (shopify.theme && shopify.theme.role && shopify.theme.role !== 'main');
    const preview = Boolean(previewAllowed && (new URLSearchParams(window.location.search).get('clad_welcome_preview') === '1' || dialog.dataset.preview === 'true'));
    if (shopify.designMode && !preview) return;
    dialog.dataset.cladReady = 'true';

    const storageKey = 'clad_welcome_popup_v1';
    const positive = (value, fallback) => Number.isFinite(Number(value)) && Number(value) > 0 ? Number(value) : fallback;
    const firstDelay = positive(dialog.dataset.firstDelay, 30000);
    const secondDelay = Math.max(firstDelay, positive(dialog.dataset.secondDelay, 90000));
    const duration = positive(dialog.dataset.countdownDuration, 180000);
    const emptyState = () => ({ version: 1, elapsed: preview ? firstDelay : 0, shown: 0, deadline: 0, finished: false });
    let storage;
    let automaticEnabled = true;
    const disableAutomatic = () => {
      automaticEnabled = false;
      storage = undefined;
    };
    try { if (!preview) storage = window.sessionStorage; } catch (_) { return; }
    if (!preview && !storage) return;

    const readState = () => {
      let serialized;
      try {
        serialized = storage.getItem(storageKey);
      } catch (_) {
        disableAutomatic();
        return null;
      }
      if (serialized === null) return emptyState();
      try {
        const saved = JSON.parse(serialized);
        if (saved && saved.version === 1 && Number.isFinite(saved.elapsed) && saved.elapsed >= 0 && [0, 1, 2].includes(saved.shown) && Number.isFinite(saved.deadline) && saved.deadline >= 0 && typeof saved.finished === 'boolean' && Boolean(saved.shown) === Boolean(saved.deadline)) return saved;
      } catch (_) {}
      try {
        storage.removeItem(storageKey);
      } catch (_) {
        disableAutomatic();
        return null;
      }
      return emptyState();
    };

    let state = preview ? emptyState() : readState();
    if (!state) return;
    let lastSave = 0;
    const saveState = (force = false) => {
      if (preview) return true;
      if (!storage) return false;
      if (!force && performance.now() - lastSave < 1000) return true;
      try {
        storage.setItem(storageKey, JSON.stringify(state));
        lastSave = performance.now();
        return true;
      } catch (_) {
        disableAutomatic();
        return false;
      }
    };
    if (!saveState(true)) return;

    const timer = dialog.querySelector('[data-clad-timer]');
    const progress = dialog.querySelector('[data-clad-progress]');
    const copyButton = dialog.querySelector('[data-clad-copy]');
    const feedback = dialog.querySelector('[data-clad-copy-feedback]');
    const label = copyButton && (copyButton.querySelector('[data-clad-copy-label]') || copyButton);
    const originalLabel = label && label.textContent;
    let visible = document.visibilityState === 'visible' && !document.prerendering;
    let active = true;
    let previousFocus;
    let previousScroll;
    let lastTick = performance.now();
    let timeout;
    let feedbackTimeout;

    const updateElapsed = () => {
      const now = performance.now();
      if (active && visible && !state.finished) state.elapsed += Math.max(0, now - lastTick);
      lastTick = now;
    };

    const renderCountdown = () => {
      const remaining = state.deadline ? Math.max(0, state.deadline - Date.now()) : duration;
      const seconds = Math.ceil(remaining / 1000);
      if (timer) timer.textContent = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
      if (progress) {
        const ratio = Math.min(1, remaining / duration);
        if (progress.tagName === 'PROGRESS') {
          progress.max = duration / 1000;
          progress.value = remaining / 1000;
        } else {
          progress.style.setProperty('--clad-progress', String(ratio));
          progress.style.transform = `scaleX(${ratio})`;
        }
      }
      return remaining;
    };

    const hasOtherModal = () => Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"], .modal.is-open, .modal--is-active, .drawer.is-open, .drawer--is-open, .drawer--is-visible, [data-el="popup"], [data-el="bag"], [data-el="menu"], [data-el="filter"], [data-el="search"], .shopify-pc__banner')).some((element) => {
      if (element === dialog || dialog.contains(element) || element.hidden || !element.getClientRects().length) return false;
      const style = getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0' && rect.width > 0 && rect.height > 0 && rect.right > 0 && rect.bottom > 0 && rect.left < window.innerWidth && rect.top < window.innerHeight;
    });

    const showDialog = (occurrence) => {
      if (!automaticEnabled || hasOtherModal()) return false;
      const previousState = { ...state };
      state.shown = occurrence;
      if (!state.deadline) state.deadline = Date.now() + duration;
      if (!saveState(true)) {
        state = previousState;
        return false;
      }
      previousFocus = document.activeElement;
      previousScroll = { x: window.scrollX, y: window.scrollY };
      try {
        dialog.showModal();
      } catch (_) {
        state = previousState;
        saveState(true);
        return false;
      }
      document.documentElement.classList.add('clad-welcome-open');
      if (!previousState.deadline) state.deadline = Date.now() + duration;
      saveState(true);
      renderCountdown();
      return true;
    };

    const tick = () => {
      clearTimeout(timeout);
      if (!active) return;
      updateElapsed();
      if (state.finished) return;
      if (state.deadline && Date.now() >= state.deadline) {
        state.finished = true;
        renderCountdown();
        saveState(true);
        if (dialog.open) dialog.close();
        return;
      }
      if (visible && automaticEnabled) {
        if (state.shown === 0 && state.elapsed >= firstDelay) showDialog(1);
        if (state.shown === 1 && state.elapsed >= secondDelay) {
          if (dialog.open) {
            state.shown = 2;
            saveState(true);
          } else showDialog(2);
        }
      }
      if (dialog.open) renderCountdown();
      saveState();
      let delay = 1000;
      const nextDelay = state.shown === 0 ? firstDelay : state.shown === 1 ? secondDelay : Infinity;
      if (visible && nextDelay > state.elapsed) delay = Math.min(delay, Math.max(25, nextDelay - state.elapsed));
      if (state.deadline) delay = Math.min(delay, Math.max(25, state.deadline - Date.now()));
      if ((visible && automaticEnabled) || state.deadline) timeout = setTimeout(tick, delay);
    };

    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('clad-welcome-open');
      if (previousFocus && previousFocus.isConnected && typeof previousFocus.focus === 'function') previousFocus.focus({ preventScroll: true });
      if (previousScroll && (window.scrollX !== previousScroll.x || window.scrollY !== previousScroll.y)) window.scrollTo(previousScroll.x, previousScroll.y);
      previousFocus = undefined;
      previousScroll = undefined;
      saveState(true);
    });

    dialog.addEventListener('click', (event) => {
      if (event.target.closest('[data-clad-close]')) dialog.close();
      else if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    });

    const fallbackCopy = (code) => {
      const selectedFocus = document.activeElement;
      const field = document.createElement('textarea');
      field.value = code;
      field.tabIndex = -1;
      field.setAttribute('aria-hidden', 'true');
      field.style.cssText = 'position:fixed;opacity:0;pointer-events:none;';
      dialog.appendChild(field);
      field.select();
      let copied = false;
      try { copied = document.execCommand('copy'); } catch (_) {}
      field.remove();
      if (selectedFocus && selectedFocus.isConnected) selectedFocus.focus({ preventScroll: true });
      return copied;
    };

    if (copyButton) copyButton.addEventListener('click', async () => {
      const code = dialog.dataset.code || 'WELCOME10';
      let copied = false;
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(code);
          copied = true;
        }
      } catch (_) {}
      if (!copied) copied = fallbackCopy(code);
      const message = copied ? dialog.dataset.copySuccess : dialog.dataset.copyFailed;
      if (feedback && message) {
        feedback.textContent = message;
        feedback.hidden = false;
      }
      if (label && copied && message) label.textContent = message;
      clearTimeout(feedbackTimeout);
      feedbackTimeout = setTimeout(() => {
        if (label) label.textContent = originalLabel;
        if (feedback) feedback.hidden = true;
      }, 3000);
    });

    document.addEventListener('visibilitychange', () => {
      updateElapsed();
      visible = document.visibilityState === 'visible' && !document.prerendering;
      saveState(true);
      tick();
    });
    window.addEventListener('pagehide', () => {
      updateElapsed();
      saveState(true);
      active = false;
      clearTimeout(timeout);
      if (dialog.open) dialog.close();
    });
    window.addEventListener('pageshow', () => {
      if (active) return;
      if (storage) state = readState() || state;
      active = true;
      visible = document.visibilityState === 'visible' && !document.prerendering;
      lastTick = performance.now();
      tick();
    });

    tick();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
